export default {

	init() {
		console.log('init footer...');
		document.addEventListener("DOMContentLoaded", this.bindEvents);
	},

	bindEvents() {
		if (!document.querySelector('.footer-nav')) {
			return;
		}

		const nav = document.querySelector('.footer-nav');
        const subnavElements = nav.querySelectorAll(':scope > ul > li');

        Footer.nav = nav;
        Footer.subnavElements = subnavElements;

		console.log(Footer.subnavElements);

		Footer.navState();

		// Listen for resize and reset menus
        window.addEventListener('resize', Footer.navState, false);
	},

	toggleSubnav(e) {
        e.preventDefault();
        var toggle = e.currentTarget;
        var parent = toggle.parentElement;
        var submenu = (parent) ? parent.querySelector(':scope > .submenu') : null;

        if (!toggle || !submenu) {
            return;
        }

        if (submenu.classList.contains('is-active')) {
            Footer.closeSubnav(toggle, submenu);
        } else {
            Footer.openSubnav(toggle, submenu);
        }
    },

	openSubnav(toggle, submenu) {
		if (!toggle || !submenu) {
            return;
        }

        toggle.setAttribute('aria-expanded', 'true');
        submenu.classList.add('is-active');
		submenu.removeAttribute('hidden');
	},

	closeSubnav(toggle, submenu) {
        if (!toggle || !submenu) {
            return;
        }

        toggle.setAttribute('aria-expanded', 'false');
        submenu.classList.remove('is-active');
		submenu.setAttribute('hidden', '');
    },

	navState() {
		console.log('footer resize');
		Footer.subnavElements.forEach(elem => {
			var toggle = elem.querySelector(':scope > [role]');
        	var parent = elem;
        	var submenu = elem.querySelector(':scope > .submenu');

			if (!toggle || !submenu) {
				return;
			}

			if(Common.isMobile('549px')) {
				toggle.setAttribute('aria-haspopup', 'true');
				toggle.setAttribute('role', 'button');
				submenu.classList.add('collapsible');
				Footer.openSubnav(toggle, submenu);
				toggle.addEventListener('click', Footer.toggleSubnav);
			} else {
				toggle.setAttribute('aria-haspopup', 'false');
				toggle.setAttribute('role', 'none');
				submenu.classList.remove('collapsible');
				Footer.openSubnav(toggle, submenu);
				toggle.removeEventListener('click', Footer.toggleSubnav);
			}
		});

	},
};
